import React, { useState } from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import { cronosTokens } from '@pancakeswap/tokens'
import { Text, TooltipText, useTooltip } from '@pancakeswap/uikit'
import { useTranslation } from '@pancakeswap/localization'
import { getBalanceNumber } from 'utils/formatBalance'

const AvailableReward: React.FC<{
  reward: BigNumber;
  penaltyAppliedReward: BigNumber;
  penaltyPercent: number;
  lastRewardAt: number;
}> = ({ reward, penaltyAppliedReward, penaltyPercent, lastRewardAt }) => {
  const { t } = useTranslation()
  const candyToken = cronosTokens.candy
  const { targetRef, tooltip, tooltipVisible } = useTooltip(
    <>
      <Text>
        {t('Available reward: %reward%', {
          reward: `${getBalanceNumber(reward, candyToken.decimals)
            .toLocaleString('en-US', { maximumFractionDigits: 5 })} ${candyToken.symbol}`
        })}
      </Text>
      <Text>{t('Earned since your last claim')}:</Text>
      <Text mb="4px">{new Date(lastRewardAt * 1000).toLocaleString()}</Text>
      {
        penaltyPercent > 0 && (
          <>
            <Text>{t('If you claim now')}:</Text>
            <Text>{t('%penaltyPercent%% early claim penalty fee applied, and you get %penaltyAppliedReward% only.', {
              penaltyPercent: penaltyPercent / 100,
              penaltyAppliedReward: `${getBalanceNumber(penaltyAppliedReward, candyToken.decimals)
                .toLocaleString('en-US', { maximumFractionDigits: 5 })} ${candyToken.symbol}`
            })}</Text>
          </>
        )
      }
    </>,
    { placement: 'bottom-start' },
  )

  return (
    <>
      {tooltipVisible && tooltip}
      <TooltipText ref={targetRef}>
        {getBalanceNumber(reward, candyToken.decimals)
          .toLocaleString('en-US', { maximumFractionDigits: 5 })} {candyToken.symbol}
      </TooltipText>
    </>
  )
}

export default AvailableReward
